import { render, staticRenderFns } from "./sideNavBar.vue?vue&type=template&id=5b709c80"
import script from "./sideNavBar.vue?vue&type=script&lang=js"
export * from "./sideNavBar.vue?vue&type=script&lang=js"
import style0 from "./sideNavBar.vue?vue&type=style&index=0&id=5b709c80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports